"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PauseOutline = {
    name: 'pause',
    theme: 'outline',
    nameWithTheme: 'pause-o',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z'
            },
            children: []
        }
    ]
};
exports.default = PauseOutline;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.0@@ant-design/icons/lib/outline/PauseOutline.js
// module id = 964
// module chunks = 0 1